@if (cart$ | async; as cart) {
  <div class="cx-add-to-saved-cart-container add-to-saved-cart__container">
    <button class="btn btn-secondary  link add-to-saved-cart__btn first-btn col-lg-3" (click)="onDelete()">
      <span>{{ 'uigAddToSavedCart.emptyCart' | cxTranslate }}</span>
    </button>
    @if (!isRestricted) {
      <button #element class="btn btn-secondary link add-to-saved-cart__btn col-lg-3" (click)="saveCart(cart)" cxAutoFocus>
        <span>{{ 'addToSavedCart.saveCartForLater' | cxTranslate }}</span>
      </button>
    }
      <button class="btn btn-secondary link add-to-saved-cart__btn col-lg-3" [routerLink]="
          {
            cxRoute: 'savedCarts'
          } | cxUrl
        " cxAutoFocus>
      <span>{{ 'addToSavedCart.savedCarts' | cxTranslate }}</span>
    </button>
    <button class="btn btn-secondary  link add-to-saved-cart__btn col-lg-3" (click)="onExport()">
      <span>{{ 'uigAddToSavedCart.printExport' | cxTranslate }}</span>
    </button>
  </div>
}
